import { render, staticRenderFns } from "./DonateCardStepTwoSelectYear.vue?vue&type=template&id=063ae330&"
import script from "./DonateCardStepTwoSelectYear.vue?vue&type=script&lang=js&"
export * from "./DonateCardStepTwoSelectYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports